import Link from 'next/link'
import styled from 'styled-components'

import { Button } from '@/components/elements/Button'
import { NewsItem } from '@/components/elements/News/NewsItem'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'

import { NewsRelease as NewsReleaseType } from '@/types/newsRelease'

type Props = {
  newsList: readonly NewsReleaseType[]
}

export const NewsRelease = ({ newsList }: Props) => {
  return (
    <div>
      <SectionTitle
        titleText="News Release"
        subTitleText="ニュースリリース"
        color="normal"
      />
      <Spacer h={{ sp: 40, pc: 70 }} />
      <NewsList>
        {newsList.map(({ _id, tag, title, publishDate }, index) => (
          <NewsItem
            key={_id}
            link={`/news/release/${_id}`}
            title={title}
            publishDate={publishDate}
            tag={tag}
            isNotShowBottom={index === 2}
          />
        ))}
      </NewsList>
      <MoreButtonWrapper>
        <Link href="/news/release" passHref>
          <a>
            <Button btnStyle="transparent">一覧を見る</Button>
          </a>
        </Link>
      </MoreButtonWrapper>
    </div>
  )
}

const NewsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const MoreButtonWrapper = styled.div`
  margin-top: 38px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 1047px) {
    margin-top: 40px;
  }
`
